import { atom } from "recoil";

const locationTimerAtom = atom({

    key:"location",
    default: null

});

export default locationTimerAtom;